module.exports = __webpack_public_path__ + "static/media/ios-text.7785a234.svg";